import { Heading, VStack } from "@chakra-ui/layout";
import { Grid } from "@chakra-ui/react";
import React from "react";

const Section: React.FC<{ title?: string; columns?: number }> = ({
  children,
  title,
  columns = 4,
}) => {
  return (
    <VStack spacing={4} alignItems="start">
      {title && <Heading size="md">{title}</Heading>}
      <Grid templateColumns={`repeat(${columns}, 1fr)`} gap={4} width={"100%"}>
        {children}
      </Grid>
    </VStack>
  );
};

export default Section;
